
export default {
  name: "TotalizadorCadastros",
  data() {
    return {
      produtoSelecionado: "produtos",
    };
  },
  props: {
    totaisCadastros: {
      type: Object,
      default: () => ({ produtos: 0, pessoas: 0 }),
    },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  computed: {
    pessoas() {
      return Number(this.totaisCadastros?.pessoas ?? 0);
    },
    produtoSelecionadoLabel() {
      return this.produtoSelecionado === "produtos_estoque"
        ? "Produtos em Estoque"
        : "Produtos";
    },
    produtos() {
      return Number(
        this.totaisCadastros?.[this.produtoSelecionado] ??
          this.totaisCadastros?.produtos ??
          0
      );
    },
  },
};
